import { BaseModel } from '../core/abstractions/base.model';
import { EntityTypeEnum } from './enums/entity-type.enum';

export class FavoriteModel extends BaseModel {
    tableName: EntityTypeEnum;
    recordId: number;
    label?: string;

    constructor(init: FavoriteModel) {
        super();
        Object.assign(this, init);
    }
}
